import styled from '@emotion/styled';
import {TextSmall, Img, Submit, MainTitleDark as MainTitleDarkUI} from 'ui';
import {colors, fonts} from 'ui/config';
import frise from 'assets/img/friseSmall.svg';

export const MainTitleDark = styled(MainTitleDarkUI)({
  marginBottom: 16,
  marginTop: 30,
  fontSize: 26,
});

export const DateBlock = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: colors.caramel,
  width: 136,
  height: 45,
  fontFamily: fonts.title,
  color: colors.white,
  fontWeight: 'bold',
});

export const FormationTeaser = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  textAlign: 'center',
  height: 370,
  width: 320,
  marginTop: 16,
  backgroundColor: colors.white,
  backgroundImage: `url(${frise})`,
  backgroundRepeat: 'repeat-x',
  backgroundPosition: 'bottom left',
});

export const Image = styled(Img)({
  width: 172,
  height: 148,
  backgroundSize: 'cover',
  objectFit: 'contain',
  backgroundColor: colors.white,
});

export const Title = styled('div')({
  color: colors.caramel,
  fontFamily: fonts.title,
  fontWeight: 'bold',
  fontSize: 26,
});

export const SubTitle = styled(TextSmall)({
  color: colors.darkBrown,
  fontSize: 16,
  textAlign: 'center',
  margin: 0,
  marginTop: 7,
});

export const Button = styled(Submit)({
  width: 'min-content',
  whiteSpace: 'nowrap',
  marginBottom: 40,
});
